import { Toast } from "antd-mobile-v2";

export const tipError = (error) => {
  console.log(error);
  Toast.info(111, 2);
  return null;
};
export const loadingShow = () => {
  document.body.style.overflow = "hidden";
  Toast.loading("加载中", 0, null, true);
};
export const loadingHide = () => {
  document.body.style.overflow = "";
  Toast.hide();
};
